module.exports = __webpack_public_path__ + "img/New Project (7).80c69ff1.png";